import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { keys } from "../../api/queryKeys.ts";
import { api } from "../../api/client.ts";
import { useTenant } from "../../contexts/TenantContext.tsx";
import ContactProfileSections, { contactLocation } from "./components/ContactProfileSections.tsx";
import PageHeader from "../../components/PageHeader.tsx";
import DetailPageStatus from "../../components/detail/DetailPageStatus.tsx";

export default function ContactDetailPage() {
  const { id } = useParams<{ id: string }>();
  const { tenantPath } = useTenant();

  const { data, isLoading, isError } = useQuery({
    queryKey: keys.masterContact.detail(id),
    queryFn: () => api.getMasterContact(id!),
    enabled: Boolean(id),
  });

  const back = { to: tenantPath("/contacts"), label: "Contacts" };

  if (isLoading || isError || !data) {
    return <DetailPageStatus isLoading={isLoading} message="Contact not found." back={back} />;
  }

  const location = contactLocation(data);

  return (
    <Box>
      <PageHeader
        back={back}
        title={data.full_name}
        description={
          (data.profile?.headline || data.birth_year || location || data.is_deceased) && (
            <Stack direction="row" spacing={2} useFlexGap sx={{ alignItems: "center", flexWrap: "wrap" }}>
              {data.profile?.headline && <span>{data.profile.headline}</span>}
              {data.birth_year && <span>b. {data.birth_year}</span>}
              {location && <span>{location}</span>}
              {data.is_deceased && <Chip label="Deceased" size="small" color="default" />}
            </Stack>
          )
        }
      />

      <ContactProfileSections contact={data} />
    </Box>
  );
}
